module.exports = __webpack_public_path__ + "media/67_Long.b172c5ee.mp3";